/* eslint jsx-a11y/alt-text: 0, no-useless-escape:0 */
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
// import Rating from 'react-rating';
import { Link } from 'react-router-dom';
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';
// import LazyLoad from 'react-lazyload';
import { moneyFormat, getPromotionName, gtm, generateGTMItemValue, getVariantGroupName, pixelAddToWishList, getRoute } from '../../assets/util'; //twoDigit, getVariantValue
import { getTranslate } from 'react-localize-redux';
import { addToCart } from '../../actions/shopping-cart';
import { toggleWishlistItem } from '../../actions/profile';
import { showAuthenticationPopup } from '../../actions/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBag, faStar } from '@fortawesome/pro-solid-svg-icons';
// import { faBell } from '@fortawesome/pro-light-svg-icons';
import { swal, close } from 'react-redux-sweetalert';
import exclusiveImg from '../../assets/img/only-at-B-app.png';
import '../../assets/beautrium-css/product-card.scss';

const noImg = 'https://cdn.thebeautrium.com/image-product/no_image.jpg';

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}


class ProductCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hover: false,
            wishlistHover: false,
            timeDiff: 0,
            d: 0,
            h: 0,
            m: 0,
            s: 0,
            expireDate: null,
            isWidthEnough: true,
            uuid: null,
        }
        this.timer = 0;
        this.countdown = this.countdown.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.productCard = React.createRef()
        this.onAddToCart = this.onAddToCart.bind(this);
        this.getFlashsalePrice = this.getFlashsalePrice.bind(this);
    }

    componentDidMount() {
        const { promotionValidTo } = this.props;
        // let promotionValidTo = "2018-03-28 12:00:00";
        if (promotionValidTo !== "" && typeof promotionValidTo !== "undefined") {
            const m = moment(promotionValidTo);
            let diff = Math.abs(m.diff(moment(), 'seconds'));
            this.setState({ timeDiff: diff });

            this.timer = setInterval(this.countdown, 1000);
        }
        if (this.productCard && this.productCard.current) {
            if (this.productCard.current.offsetWidth < 190) {
                this.setState({ isWidthEnough: false });
            }
        }
        this.setState((prev) => { return { uuid: uuidv4() } })
        window.addEventListener("resize", this.updateDimensions);

    }

    componentDidUpdate(prevProps) {
        if (this.productCard && this.productCard.current) {
            if (this.productCard.current.offsetWidth < 190) {
                this.setState({ isWidthEnough: false });
            }
        }
        if (typeof this.props.postWistlistFunc === "function") {
            if (this.props.addWishlistResult === true && !prevProps.addWishlistResult && this.props.wishlistID === this.state.uuid) {
                this.props.postWistlistFunc()
            }
            if (this.props.deleteWishlistResult === true && !prevProps.deleteWishlistResult && this.props.wishlistID === this.state.uuid) {
                this.props.postWistlistFunc()
            }

        }
    }

    componentWillUnmount() {
        if (this.state.expireDate === null) {
            clearInterval(this.timer);
        }
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        if (this.productCard && this.productCard.current) {
            this.setState({ isWidthEnough: this.productCard.current.offsetWidth >= 170 });
        }
    }

    countdown() {
        let newDiff = this.state.timeDiff - 1;
        let days = Math.floor(newDiff / (60 * 60 * 24));

        let divisor_for_hours = newDiff % (60 * 60 * 24);
        let hours = Math.floor(divisor_for_hours / (60 * 60));

        let divisor_for_minutes = newDiff % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        this.setState({
            timeDiff: newDiff,
            d: days,
            h: hours,
            m: minutes,
            s: seconds
        })
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !_.isEqual(nextProps, this.props);
    }

    wishlistToggle(mat_var_id, wishlisted = 0) {
        const { authenticated, showAuthenticationPopup, toggleWishlistItem } = this.props;
        if (authenticated) {
            toggleWishlistItem(mat_var_id, wishlisted === 0, this.state.uuid);
            if (!wishlisted) {
                gtm("add_to_wishlist", generateGTMItemValue(this.props.item, 1, 0))
                pixelAddToWishList(this.props.item)
            }
        } else {
            showAuthenticationPopup(true);
        }
    }

    onAddToCart(e, { itemMaterial, qty = 1, showNotification, addToIndex, soldOut }) {
        const { swal, close } = this.props;
        e.preventDefault(); e.stopPropagation();
        if (soldOut) {
            fetch(getRoute(`/api/material/soldout`), {
                method: "post",
                body: JSON.stringify({ mat_var_id: itemMaterial.mat_var_id }),
                credentials: 'include',
                accept: 'application/json',
            }).catch((error) => { console.log(error) });
            return swal({
                title: "ขออภัยค่ะ",
                text: "ขออภัยคุณลูกค้าค่ะ สินค้านี้ได้หมดแล้ว ทางบิวเทรี่ยมจะดำเนินการเติมโดยเร็วที่สุดค่ะ",
                type: 'error',
                customClass: 'bt-dialog-box',
                onConfirm: close
            })
        } else {
            return this.props.addToCart(itemMaterial, qty, showNotification, addToIndex)
        }
    }

    getFlashsalePrice() {
        const { item } = this.props;
        const now = moment();
        const flashsale = _.get(item, "flashsale[0]", {}) || {}
        if (!_.isEmpty(flashsale) && now.isBetween(flashsale.start_date, flashsale.end_date, "d", "[]")) {
            return moneyFormat(flashsale.fs_price || item.net_price || item.mat_price, '฿')
        } else { //if (!flashsale || now.isBefore(flashsale.start_date)) 
            const str = parseFloat(flashsale.fs_price || item.net_price || item.mat_price)
            if (str < 10) {
                return "?"
            }
            let result = "";
            _.each("" + str, (s, i) => {
                if (i === 0) {
                    result += s;
                } else {
                    result += "?";
                }
            })
            return result;
        }
    }

    render() {
        const { addToCartAt, scrollPosition } = this.props; //authenticated, seekTo, translate, 
        // const {d, h, m, s} = this.state;
        // const {expireDate} = this.state;
        const { item, free, review, notShowLabelPrice, disableBuy, lazyLoad, showOnlyOneButton } = this.props; //promotionValidTo
        // const proValidTo = promotionValidTo? promotionValidTo: "";
        // const size = typeof item !== "undefined"? (getVariantValue(item, "Volume")? getVariantValue(item, "Volume").name: null): null;
        // const showCountDown = proValidTo !== "" && expireDate === null;
        // const wishlisted = (typeof item !== "undefined" && item) ? (item.wishlisted ? item.wishlisted : 0) : 0;
        // const showWishlist = typeof this.props.showWishlist !== "undefined" ? this.props.showWishlist : true;
        const showFlashsale = _.get(this.props, "showFlashsale", false);
        const soldOut = _.get(item, "sold_out", true) // || _.get(item, "limit", 0) === 0
        const itemMaterial = (typeof item === "undefined" || !item) ? { mat_no: 5, brand_en: 'BRAND', mat_name: 'Disney Princess Apple Mask', img: "https://www.konvy.com/static/team/2017/0828/15038964742139_280x280.jpg", mat_price: 99, net_price: 99, original_price: 99, qty: 1, curr: 'THB', best: 9999 } : item;
        const net_price = free ? 0 : (itemMaterial.net_price ? itemMaterial.net_price : itemMaterial.mat_price);
        const label_price = notShowLabelPrice ? 0 : itemMaterial.mat_label_price ? itemMaterial.mat_label_price : itemMaterial.mat_price;
        let promotion = (typeof item !== "undefined" && item) ? ((item.promotion || (net_price !== item.mat_label_price)) ? getPromotionName(item) : "") : "";
        const isMemberPromotion = itemMaterial.member_value ? true : false;
        const showPrice = typeof this.props.showPrice !== "undefined" ? this.props.showPrice : true;
        const showSold = this.props.showSold ? this.props.showSold : false;
        const showIconAddToCart = typeof this.props.showIconAddToCart !== "undefined" ? this.props.showIconAddToCart : true;
        // const showAddToCartText = typeof this.props.showAddToCartText !== "undefined"? this.props.showAddToCartText: true; //this.state.isWidthEnough && (
        const showRating = typeof this.props.showRating !== "undefined" ? this.props.showRating : true;
        const showNotification = typeof this.props.showNotification !== "undefined" ? this.props.showNotification : true;
        const showPromotion = typeof this.props.showPromotion !== "undefined" ? this.props.showPromotion : true;

        // const showStatus = false//typeof this.props.showStatus !== "undefined"? this.props.showStatus: true;
        // let status = (showStatus && item.best < 100)? 'Best Seller': "";
        const addToIndex = addToCartAt ? addToCartAt : null;
        const lazyLoading = typeof lazyLoad !== "undefined" ? lazyLoad : true;
        const affiliate = _.isEmpty(review) ? false : review;
        if (affiliate) {
            itemMaterial.review_id = affiliate.review_id
            itemMaterial.buy_from = affiliate.user_id
        }
        const variant = itemMaterial.variant_count > 1 ? { count: itemMaterial.variant_count, name: itemMaterial.variant_group } : null
        const gwp = itemMaterial.gwp ? _.sortBy(itemMaterial.gwp, g => g.priority) : null
        const showGWP = typeof this.props.showGWP !== "undefined" ? this.props.showGWP : (gwp !== null && gwp.length > 0)
        const newTab = this.props.newTab ? { target: "_blank", rel: "noopener noreferrer" } : {};
        const exclusive = item ? item.exclusive === 1 : false;
        const isProductNew = item ? item.new === 1 : false;
        const showOneButton = typeof showOnlyOneButton !== "undefined" ? showOnlyOneButton : false;
        const showButtons = typeof this.props.showButtons !== "undefined" ? this.props.showButtons : true;
        // console.log(itemMaterial);
        return (
            <div ref={this.productCard} className="bt-product-card">
                <Link to={`/item/${itemMaterial.mat_id}/${itemMaterial.mat_var_id}`} {...newTab} onClick={(e) => {
                    if (this.props.disableLink) {
                        e.preventDefault()
                    } else {
                        // gtm('select_content', {content_type: 'product', items: [{id: itemMaterial.item_id, brand: itemMaterial.brand_en, name: itemMaterial.mat_name + (size? ' ' + size: '') + (itemMaterial.variant_2? ' ' + itemMaterial.variant_2: ''), }]})
                    }
                }}>
                    {/* <Link to={`/item/${itemMaterial.brand_en}/${encodeURIComponent(itemMaterial.mat_name.replaceAll("/", "%2F"))}/${itemMaterial.mat_var_id}`}> */}
                    <div className="product-image">
                        {lazyLoading
                            ? <LazyLoadImage scrollPosition={scrollPosition} src={itemMaterial.image_1 ? itemMaterial.image_1 : noImg} alt={itemMaterial.mat_name} effect="opacity" threshold="300" />
                            : <img src={itemMaterial.image_1 ? itemMaterial.image_1 : noImg} alt={itemMaterial.mat_name} />
                        }
                        {(showPromotion) &&
                            <div className={`pro-exclusive-overlay`}>
                                {(promotion && promotion !== "") ? <div className="promotion">{promotion}</div> : null}
                                {exclusive && <div className=""><img src={exclusiveImg} alt="Exclusive" style={{ width: 45, height: 45, top: 40 }} /></div>}
                            </div>
                        }
                        {/* {showWishlist && <div className={`wishlist ${wishlisted === 1? "wishlisted": ""}`} onClick={(e) => {e.preventDefault(); this.wishlistToggle(item.mat_var_id, wishlisted);}} ><FontAwesomeIcon icon={["fal", "heart"]} /><FontAwesomeIcon icon={["fas", "heart"]} /></div>} */}
                        {showGWP && <div className={`gwp-overlay`}>FREE<div className={`gwp-cover`}><img src={gwp.cover_image || _.get(gwp, "[0].cover_image.url", "")} alt={_.get(gwp, "[0].name")} /></div></div>}
                        {soldOut
                            ? <div className="soldout-overlay">หมด</div>
                            : null}
                    </div>
                    <div className="sub-variant">
                        {isProductNew ? <div className="new">New</div> : null}
                        {variant ? <div className={`variant`}>มี {variant.count} {getVariantGroupName(variant.name)}</div> : null}
                    </div>
                    <div className={`product-detail ${showButtons ? "" : "text-center"}`}>
                        <div className="brand"><span className="">{itemMaterial.brand_en}</span></div>
                        <div className="name"><span className="">{itemMaterial.mat_name}</span></div>
                        {/* <div className="size"><span className="">{size? size: ""}</span></div> */}
                        {/* <div className="price"><span className="sale-price">{moneyFormat(itemMaterial.mat_price, '฿')}</span> {itemMaterial.mat_price !== itemMaterial.mat_label_price && <span className={`original-price`}>{moneyFormat(itemMaterial.mat_label_price, '฿')}</span>}</div> */}
                        <div className={`price-cmd-row ${showButtons ? "" : "no-buttons"}`}>
                            <div className="price">
                                {showPrice
                                    ? <div className={`sale-price ${((net_price && net_price !== label_price) || showFlashsale) ? "has-promotion" : ""}`}>{showFlashsale ? this.getFlashsalePrice() : moneyFormat(net_price !== null ? net_price : itemMaterial.mat_price, '฿')}</div>
                                    : null}
                                {showPrice
                                    ? isMemberPromotion ? <span className="member-price">ราคาสมาชิก</span> : <div className="original-price">{((net_price !== null && net_price !== label_price) || showFlashsale) && moneyFormat(label_price, '฿')}</div>
                                    : null}
                                <div className="sold-container">
                                    {showSold
                                        ? <div className="sold"><FontAwesomeIcon icon={faShoppingBag} color="#db0032" /> (300)</div>
                                        : null}
                                    {(!showSold && showRating)
                                        ? <div className="product-rating"><FontAwesomeIcon icon={faStar} color="#db0032" /> | {item.rating} ({item.rating_count})</div>
                                        : null}
                                </div>
                            </div>
                            {showButtons
                                ? <div className="commands">
                                    {/* {(soldOut && showWishlist)
                                            ? <button type="button" className="btn btn-black" onClick={(e) => { e.preventDefault(); this.wishlistToggle(item.mat_var_id, wishlisted); }}><FontAwesomeIcon icon={faBell} /></button>
                                            : null} */}
                                    {/* <button type="button" className="btn btn-black" onClick={(e) => this.onAddToCart(e, { itemMaterial, qty: 1, showNotification, addToIndex, soldOut })} disabled={disableBuy}>{showIconAddToCart && <FontAwesomeIcon icon={["fal", "shopping-cart"]} />}</button> */}
                                    {(showOneButton && soldOut)
                                        ? null
                                        : <button type="button" className="btn btn-black" onClick={(e) => this.onAddToCart(e, { itemMaterial, qty: 1, showNotification, addToIndex, soldOut })} disabled={disableBuy}>{showIconAddToCart && <FontAwesomeIcon icon={["fal", "shopping-cart"]} />}</button>}
                                </div>
                                : null}
                        </div>

                        {/* <div className={`rating ${showCountDown? "with-countdown": ""}`}>
                            {showRating && <Rating 
                                emptySymbol={<FontAwesomeIcon icon={["fal", "star"]} style={{color: "#ccc"}} />}
                                fullSymbol={<FontAwesomeIcon icon={["fas", "star"]} style={{color: "#DB1F35"}} />}
                                initialRating={parseFloat(itemMaterial.rating)}
                                readonly
                            />}
                        </div> */}
                        {/* {showCountDown && 
                            <div className="countdown">
                                {d > 0 && <div className="cd-unit"><span className="hhmmss">{d}</span><span className="unit">Day</span></div>}:
                                <div className="cd-unit"><span className="hhmmss">{twoDigit(h)}</span><span className="unit">H</span></div>:
                                <div className="cd-unit"><span className="hhmmss">{twoDigit(m)}</span><span className="unit">M</span></div>:
                                <div className="cd-unit"><span className="hhmmss">{twoDigit(s)}</span><span className="unit">S</span></div>
                            </div>
                        } */}
                        {/* {proValidTo !== "" && expireDate !== null && <div className="countdown"><span className="expire">Expired at {expireDate}</span></div>} */}
                    </div>
                    {/* <div className={`tools ${showCountDown? "with-countdown": ""}`} onClick={(e) => {e.preventDefault(); e.stopPropagation();}}>
                        <div className={`addtocart`}>
                            <button className="btn btn-black" onClick={(e) => {
                                e.preventDefault(); e.stopPropagation(); 
                                this.props.addToCart(itemMaterial, 1, showNotification, addToIndex)
                            }} disabled={soldOut || disableBuy}>{showIconAddToCart && <FontAwesomeIcon icon={["fal", "shopping-cart"]}/>}{showAddToCartText && <span className="">{soldOut? translate(`SOLD_OUT`): translate(`ADD_TO_CART`)}</span>}</button></div>
                    </div> */}
                </Link>
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        translate: getTranslate(state.locale),
        addWishlistResult: state.prof.addWishlistResult,
        wishlistID: state.prof.wishlistID,
        deleteWishlistResult: state.prof.deleteWishlistResult,
    }
}
export default connect(mapStateToProps, { addToCart, toggleWishlistItem, showAuthenticationPopup, getTranslate, swal, close })(trackWindowScroll(ProductCard))
